import { isArray, isObject } from 'underscore'
import formatTemperature from './format-temperature'
import htmlEntities from './html-entities'

const prettyPrintValue = (value, key='', data = {}) => {

  if([
    'alert_temp_below',
    'alert_temp_above',
    'temp_offset',
    'tc_temp_above',
    'tc_temp_below',
  ].includes(key)) {

    value = parseFloat(value);

    if(key === 'alert_temp_below' && Math.round(value) == -99) {
      return "Unset";
    } else if(key === 'alert_temp_above' && Math.round(value) == 200) {
      return "Unset";
    } if(key === 'tc_temp_below' && Math.round(value) == -9999) {
      return "Unset";
    } else if(key === 'tc_temp_above' && Math.round(value) == 9999) {
      return "Unset";
    }

    if(value && value !== 'unset') {
      return window.formatTemperature(value);
    } else {
      return 'Unset';
    }

  }

  if([
    'alert_humidity_below',
    'alert_humidity_above',
    'humidity_offset',
  ].includes(key)) {

    if(value && value !== 'unset') {
      return value + '%';
    } else {
      return 'Unset';
    }

  }

  if([
    'heat_index_above',
    'heat_index_below',
    'dew_point_threshold',
  ].includes(key)) {

    if(value && value !== 'unset') {
      return celsiusUnitsToUserTemp(value) + "&deg;" + getUserTempPref();
    } else {
      return 'Unset';
    }

  }

  if(key === 'PWR_M') {
    if(value == 0) {
      return "Default power mode";
    } else if(value == 3) {
      return "Alert power mode";
    }

  }

  if(key === 'TC_SKIN') {
    switch(value) {
      case "CLAMP":
        return "Pipe Clamp";
      case "WINE_BOTTLE":
        return "Wine Bottle";
      case "BUFFER_BOTTLE":
        return "Buffer Bottle";
      case "DEFAULT":
        return "Default";
    }
  }

  if(key === 'send_interval' || key === 'alert_interval') {
    return window.formatSeconds(value);
  }

  if(key == 'contacts' && data.alert) {
    if(isObject(value)) {

      let return_value = '';

      Object.keys(value).forEach(contact_id => {

        let contact_name = "";

        if(window.userContacts) {
          for(let contact of window.userContacts) {
            if(contact.id == contact_id) {
              contact_name = `${contact.contact_name} (${contact_id})`;
              break;
            }
          }
        }

        if(contact_name.length === 0) {
          contact_name = `Contact ${contact_id}`;
        }

        return_value += `
         
        <li>
          ${htmlEntities(contact_name)}<br /> 
          <span class="inline-list-item">${value[contact_id].send_email == 1 ? 'Send Emails' : 'No Emails'}</span>
          <span class="inline-list-item">${value[contact_id].send_text == 1 ? ' Send Texts' : 'No Texts'}</span>
        </li>
        `;
      });

      if(!return_value) {
        return 'No contacts';
      }

      return return_value;

    }
  }

  if(key === 'active_when') {

    if(isObject(value)) {

      let return_value = '';

      Object.keys(value).forEach(day_id => {
        return_value += `
        <li>
          Day ${day_id}<br/>
          <span class="inline-list-item">Start: ${value[day_id].alert_time_start}</span>
          <span class="inline-list-item">End: ${value[day_id].alert_time_end}</span>
        </li>
        `;
      });

      if(!return_value) {
        return 'Off';
      }

      return return_value;

    }

  }

  if(key === 'reading_value') {

    if(data.alert && data.alert.reading_type === 'temperature') {
      return formatTemperature(value);
    } else {
      return value + '%';
    }

  }

  if(key === 'wlanA' || key === 'wlanB') {
    if(value === '') {
      value = 'No WiFi network'
    }
  }

  if(value == 0 && !key.match(new RegExp('name', 'i'))) {
    value = 'No';
  } else if (value == 1 && !key.match(new RegExp('name', 'i'))) {
    value = 'Yes';
  } else if(isArray(value)) {
    value = `List (${value.join(', ')})`;
  }

  return value;

};

export default prettyPrintValue;